// extracted by mini-css-extract-plugin
export default {"cardTitle":"CardTitle_cardTitle__WvmMv","titleText":"CardTitle_titleText__h3bsi","linkBox":"CardTitle_linkBox__mwoRT","link":"CardTitle_link__dkWg8"};